import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { UiComponents, UnoStoreHooks, BackArrowIcon } from "@simulanisindia/ui";
import apiClient from '../../apiClient';
import { GET_ROLE_DETAILS, ROLE_USERS, UPDATE_ROLE_DETAILS } from '../../apiClient/apiEndpoints';
import PermissionsTab from './PermissionsTab';
import { roleAssignmentTab, roleInfoTab, rolePermissionTab } from '../../utils/common';
import { checkPermissionExist, debounce } from '../../utils/general';
import BtnLoad from '../../components/BtnLoad';
import useSuccessfulModal from '../useSuccessfulModal';
import { ROLES_EDIT_PERMISSION } from '../../constant/permission';
import TabRole from './TabRole';
import { useSelector } from 'react-redux';

const { useUnoSelector } = UnoStoreHooks;
const { SimListDropDown, BackButton } = UiComponents;

const ManagePermission = ({ onlyView = false, isMobileView = null }) => {
  const navigate = useNavigate();
  const params = useParams();
  const handleOpenSuccessfulModal = useSuccessfulModal(1500, "Update Successfully.");
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const { searchValue } = useSelector((state) => state.searchSlice);
  const [preStateData, setPreStateData] = useState({
    name: "",
    description: "",
    permissionIds: [],
  });
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectPermissions, setSelectPermissions] = useState([]);
  const [activeTab, setActiveTab] = useState(onlyView ? "#role-assignments" : "#roleinfo");
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [roleUserList, setRoleUserList] = useState([]);
  const [sideBarTab, setSideBarTab] = useState([]);
  const [filterRoleUserList, setFilterRoleUserList] = useState([]);
  const [fetRoleUserLoading, setFetRoleUserLoading] = useState(true);
  const { uuid: UUID } = params;

  useEffect(() => {
    let _permissionTabForPermissions = userData?.user?.permissions || [];
    const filteredRolePermissionTab = rolePermissionTab.map(tab => {
      let _tabSubmenuList = tab.submenu.filter(item => _permissionTabForPermissions.includes(item.key))
      return ({
        ...tab,
        id_link: _tabSubmenuList.length > 0 ? _tabSubmenuList[0].id_link : "",
        submenu: _tabSubmenuList
      })
    });

    setSideBarTab([...roleInfoTab, ...roleAssignmentTab, ...filteredRolePermissionTab])
  }, [configData]);

  const getRoleDetails = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${GET_ROLE_DETAILS}/${UUID}`);
      let permissionIds = data?.permissions?.map((e) => e.id) || [];
      let name = data?.name || "";
      let description = data?.description || "";
      setName(name);
      setDescription(description);
      setSelectPermissions(permissionIds);
      setPreStateData({
        name: name,
        description: description,
        permissionIds: permissionIds,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getRoleUsers = async () => {
    try {
      setFetRoleUserLoading(true);
      let list = await apiClient.get(`${configData.config.UNO_URL}${ROLE_USERS}/${UUID}`);
      list = list.filter((user) => user.uuid !== userData.user.uuid);
      let allIds = list.map((e) => e.uuid);
      setSelectedUsers(allIds);
      setRoleUserList(list);
      setFilterRoleUserList(list);
    } catch (error) {
      console.log(error);
    } finally {
      setFetRoleUserLoading(false);
    }
  };

  const getAllGroupChildren = () => {
    try {
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {

    let list = roleUserList.filter((user) => user.name.toLowerCase().includes(searchValue.toLowerCase()));
    let allIds = list.map((e) => e.uuid);
    setSelectedUsers(allIds);
    setFilterRoleUserList(list);

  }, [searchValue, roleUserList])

  useEffect(() => {
    getRoleDetails();
    getRoleUsers();
    getAllGroupChildren();
    getAllGroupChildren();
  }, [UUID]);

  const backClick = () => navigate(-1);

  const handleUpdateRoles = async () => {
    if (loading) return;
    try {
      setLoading(true);
      let bodyData = {
        name: name,
        description: description,
        permissions: selectPermissions,
      };
      await apiClient.post(`${configData.config.UNO_URL}${UPDATE_ROLE_DETAILS}/${UUID}`, bodyData);
      handleOpenSuccessfulModal();
      getRoleDetails();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setName(preStateData.name);
    setDescription(preStateData.description);
    setSelectPermissions(preStateData.permissionIds);
  };

  const handleUpdateRolesDebounce = debounce(handleUpdateRoles, 500);

  return (
    <>

      {!isMobileView ?
        <div className="newrole-page manage-permission">
          <div className="page-title with-fuctions justify-content-between">
            <div className="title-here">
              <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
              <h6> {onlyView ? "View" : "Manage"} Permission</h6>
            </div>

            {checkPermissionExist(ROLES_EDIT_PERMISSION) && !onlyView && activeTab !== "#role-assignments" && (
              <div className="search-parent d-flex gap-2">
                <button className="cancel" onClick={handleCancel}>
                  Cancel
                </button>
                {loading ? (
                  <button className="create">
                    {" "}
                    <BtnLoad />{" "}
                  </button>
                ) : (
                  <button onClick={handleUpdateRolesDebounce} className="create">
                    {" "}
                    Submit{" "}
                  </button>
                )}
              </div>
            )}
          </div>

          <div className="newrole-card">
            <div className="newrole-sidebar">
              <SimListDropDown menuData={sideBarTab} setActiveTab={setActiveTab} activeTab={activeTab} />
            </div>
            <div className="newrole-content">
              <PermissionsTab
                onlyView={onlyView}
                fetRoleUserLoading={fetRoleUserLoading}
                getRoleUsers={getRoleUsers}
                heading="Role Information"
                roleUserList={filterRoleUserList}
                UUID={UUID}
                activeTab={activeTab}
                name={name}
                setName={setName}
                description={description}
                setDescription={setDescription}
                selectPermissions={selectPermissions}
                setSelectPermissions={setSelectPermissions}
                selectedUsers={selectedUsers}
                isMobileView={isMobileView}
              />
            </div>
          </div>
        </div>
        :
        (
          <>
            <TabRole isMobileView={isMobileView} roleUserList={filterRoleUserList} />
          </>
        )
      }

    </>
  );
};

export default ManagePermission;